/**
 * PLURAL SEM "(s)" (23/10/2026, revisão do pesquisador: "26 alunos", "1 professor", "0 convidados", nunca "aluno(s)").
 * Um é singular; zero e os outros, plural — a regra do português. O número sai com o separador de milhar ("2.438 questões").
 *   plural(26, 'aluno', 'alunos')                    → "26 alunos"
 *   plural(1, 'convite pendente', 'convites pendentes') → "1 convite pendente"
 *   palavraNoPlural(n, 'questão', 'questões')        → só a palavra, para quando o número já está escrito à parte
 */
export const palavraNoPlural = (n: number, um: string, varios: string): string => (n === 1 ? um : varios);
export const plural = (n: number, um: string, varios: string): string => `${n.toLocaleString('pt-BR')} ${palavraNoPlural(n, um, varios)}`;
